var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampfire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: .8px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14,16c.4.2,1.9-1.3,2-3.1,0-1.3-.7-2.4-1.4-3.5-.8-1.3-1.2-1.2-1.6-2.2-.8-1.7-.2-2.9-.7-3.1-.8-.4-4.1,2.8-4.2,6.6,0,2.7,1.5,5,1.6,4.9,0,0-.2-.6,0-1.3,0-.3.2-.4.6-.8.7-.8,1-1.3,1.1-1.5.4-.9,0-1.5.4-1.7.4-.2,1.7.9,2.1,2.4.5,1.8-.3,3.2,0,3.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18,20.5c0,.3-.4.5-.7.5s-.1,0-.2,0l-5.1-1.7-2.3-.8-3.1-1c-.4,0-.6-.5-.5-.9,0-.3.4-.5.7-.5s.1,0,.2,0l5,1.7,2.2.8,3.2,1.1c.4.1.6.5.5.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.7,18.5l2.3.8-5,1.6c0,0-.1,0-.2,0-.3,0-.6-.2-.7-.5-.1-.4.1-.8.5-.9l3.1-1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.4,17.4l-3.2,1.1-2.2-.8,5.1-1.7c0,0,.1,0,.2,0,.3,0,.6.2.7.5,0,.4-.1.8-.5.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampfire);
export default __webpack_public_path__ + "static/media/campfire.5411f03bed3b8fb2a10f672d431da475.svg";
export { ForwardRef as ReactComponent };